import { Component, Story, Knobs, Accents, Knob } from './DocTypes';

const SubSetPlaygroundKnobs: Knobs = {
  accent: {
    default: 'denim',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  disabled: {
    default: false,
    editor: 'checkbox',
  },
  'colour-scheme': {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', ''],
    default: '',
  },
};

const selectedOptionKnob: Knob = {
  default: 'home',
  editor: 'dropdown',
  editorOptions: ['', 'home', 'list', 'gallery'],
};

const PlaygroundKnobs = { ...SubSetPlaygroundKnobs, selectedOption: selectedOptionKnob };

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A nav bar for mobile apps',
  coreComponent_v3: {
    html: `<div style="min-width: 375px; display: flex; height: 100%; flex-direction: column; justify-content: flex-end;">
    <tag3-mobile-nav {{...knobs}}>
        <tag3-mobile-nav-option name="home" icon="HomeOutlineMobile" text="Home"></tag3-mobile-nav-option>
        <tag3-mobile-nav-option name="list" icon="DocOutlineMobile" text="List"></tag3-mobile-nav-option>
        <tag3-mobile-nav-option name="gallery" icon="PhotoOutlineMobile" text="Gallery"></tag3-mobile-nav-option>
        <tag3-mobile-nav-option name="more" icon="MoreMobile" text="More" disabled></tag3-mobile-nav-option>
    </tag3-mobile-nav>
</div>`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper_v3: {
    jsx: `<div style={{ minWidth: "375px", display: "flex", height: "100%", flexDirection: "column", justifyContent: "flex-end" }}>
    <Tag3MobileNav {{...knobs}}>
        <Tag3MobileNavOption name="home" icon="HomeOutlineMobile" text="Home"></Tag3MobileNavOption>
        <Tag3MobileNavOption name="list" icon="DocOutlineMobile" text="List"></Tag3MobileNavOption>
        <Tag3MobileNavOption name="gallery" icon="PhotoOutlineMobile" text="Gallery"></Tag3MobileNavOption>
        <Tag3MobileNavOption name="more" icon="MoreMobile" text="More" disabled></Tag3MobileNavOption>
    </Tag3MobileNav>
</div>`,
    knobs: PlaygroundKnobs,
  },
};

const SetSelectedOptionsStory: Story = {
  title: 'Set SelectedOption',
  description: 'A nav bar for mobile apps',
  coreComponent_v3: {
    html: `<div style="min-width: 375px; display: flex; height: 100%; flex-direction: column; justify-content: flex-end;">
    <div style="padding: 20px 0;">
      <tag3-button id="btnHome">Set selected to 'home'</tag3-button>
      <tag3-button id="btnList">Set selected to 'list'</tag3-button>
      <tag3-button id="btnGallery">Set selected to 'gallery'</tag3-button>
    </div>
    <tag3-mobile-nav {{...knobs}}>
        <tag3-mobile-nav-option name="home" icon="HomeOutlineMobile" text="Home"></tag3-mobile-nav-option>
        <tag3-mobile-nav-option name="list" icon="DocOutlineMobile" text="List"></tag3-mobile-nav-option>
        <tag3-mobile-nav-option name="gallery" icon="PhotoOutlineMobile" text="Gallery" disabled></tag3-mobile-nav-option>
    </tag3-mobile-nav>
</div>`,
    js: `
  myNav = document.querySelector('tag3-mobile-nav');

  btnHome = document.querySelector('#btnHome');
  btnHome.addEventListener('buttonClick', function() {
    myNav.selectedOption = 'home'
  })

  btnList = document.querySelector('#btnList');
  btnList.addEventListener('buttonClick', function() {
    myNav.selectedOption = 'list'
  })

  btnGallery = document.querySelector('#btnGallery');
  btnGallery.addEventListener('buttonClick', function() {
    myNav.selectedOption = 'gallery'
  })
    `,
    knobs: PlaygroundKnobs,
  },
  reactWrapper_v3: {
    parentJSX: `
Example = () => {
  const [selectedOption, setSelectedOption] = React.useState('home');

  return (
    <div style={{ minWidth: "375px", display: "flex", height: "100%", flexDirection: "column", justifyContent: "flex-end" }}>
      <div style={{ padding: "20px" }}>
        <Tag3Button text="Set selected to 'home'" onButtonClick={() => {setSelectedOption('home')}} />
        <Tag3Button text="Set selected to 'list'" onButtonClick={() => {setSelectedOption('list')}} />
        <Tag3Button text="Set selected to 'gallery'" onButtonClick={() => {setSelectedOption('gallery')}} />
      </div>
      <Tag3MobileNav {{...knobs}} selectedOption={selectedOption} onOptionClick={e => setSelectedOption(e.detail.name)}>
        <Tag3MobileNavOption name="home" icon="HomeOutlineMobile" text="Home"></Tag3MobileNavOption>
        <Tag3MobileNavOption name="list" icon="DocOutlineMobile" text="List"></Tag3MobileNavOption>
        <Tag3MobileNavOption name="gallery" icon="PhotoOutlineMobile" text="Gallery" disabled></Tag3MobileNavOption>
      </Tag3MobileNav>
    </div>
  )
}`,
    jsx: `
<Example />

      `,
    knobs: SubSetPlaygroundKnobs,
  },
};

const longTextStory: Story = {
  title: 'Long text option',
  description:
    'A nav bar for mobile apps. One option has a very long text. If the text does not fit inside the width, it should be truncated.',
  coreComponent_v3: {
    html: `<div style="min-width: 375px; display: flex; height: 100%; flex-direction: column; justify-content: flex-end;">
    <tag3-mobile-nav accent='denim' selected-option="home">
        <tag3-mobile-nav-option name="home" icon="HomeOutlineMobile" text="Home"></tag3-mobile-nav-option>
        <tag3-mobile-nav-option name="list" icon="DocOutlineMobile" text="This is a very long option. If the text doesn't fit inside the width, it should be truncated. All options should have the same width."></tag3-mobile-nav-option>
        <tag3-mobile-nav-option name="gallery" icon="PhotoOutlineMobile" text="Gallery" disabled></tag3-mobile-nav-option>
    </tag3-mobile-nav>
</div>`,
  },
  reactWrapper_v3: {
    jsx: `<div style={{ minWidth: "375px", display: "flex", height: "100%", flexDirection: "column", justifyContent: "flex-end" }}>
    <Tag3MobileNav accent='denim' selectedOption="home">
      <Tag3MobileNavOption name="home" icon="HomeOutlineMobile" text="Home"></Tag3MobileNavOption>
      <Tag3MobileNavOption name="list" icon="DocOutlineMobile" text="This is a very long option. If the text doesn't fit inside the width, it should be truncated. All options should have the same width."></Tag3MobileNavOption>
      <Tag3MobileNavOption name="gallery" icon="PhotoOutlineMobile" text="Gallery" disabled></Tag3MobileNavOption>
    </Tag3MobileNav>
</div>`,
  },
};

export const TagMobileNavOptionDocs: Component = {
  type: 'component',
  name: 'mobile-nav-option',
  description: 'Renders a mobile nav option',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'name',
      description: 'The nav option name',
      type: 'string',
    },
    {
      name: 'icon',
      description: 'The option icon',
      type: 'Icon',
    },
    {
      name: 'selectedIcon',
      description: 'The optional icon to show when the nav option is selected',
      type: 'Icon',
    },
    {
      name: 'text',
      description: 'The option text',
      type: 'string',
    },
    {
      name: 'disabled',
      description: 'Whether the nav is disabled',
      type: 'boolean',
    },
    {
      name: 'colour-scheme',
      description:
        'Dark mode (theme) control. Undefined for normal browser control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'optionClick',
      description: 'Triggers when a nav option is clicked',
      parameters: [
        {
          name: 'name',
          description: 'The name attribute of the nav option',
          type: 'string',
        },
      ],
    },
  ],
  methods: [],
  stories: [],
};

export const TagMobileNavDocs: Component = {
  type: 'component',
  name: 'mobile-nav',
  description: 'Renders a mobile nav',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'accent',
      description: 'The accent of the selected option',
      type: 'Accent',
    },
    {
      name: 'disabled',
      description: 'Whether the nav is disabled',
      type: 'boolean',
    },
    {
      name: 'selectedOption',
      description: 'The name of the selected option',
      type: 'string',
    },
    {
      name: 'colour-scheme',
      description:
        'Dark mode (theme) control. Undefined for normal browser control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'optionClick',
      description: 'Triggers when a nav option is clicked',
      parameters: [
        {
          name: 'name',
          description: 'The name attribute of the nav option',
          type: 'string',
        },
      ],
    },
  ],
  methods: [],
  stories: [PlaygroundStory, SetSelectedOptionsStory, longTextStory],
  childComponents: [TagMobileNavOptionDocs],
};
